import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

export default function Footer() {
  return (
    <footer className="bg-[#0D2B1F] text-white">
      {/* Main Footer Body */}
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">

          {/* Brand Column */}
          <div className="md:col-span-4 flex flex-col gap-5">
            <Link href="/homepage" className="flex items-center gap-2.5 w-fit">
              <AppLogo
                src="/assets/images/EB_logo_White_160_x_160_px_-1777167253747.png"
                size={34}
                className="rounded-md" />

              <span className="font-display font-semibold text-base tracking-tight text-white">
                EarnestBridge
              </span>
            </Link>
            <p className="text-[13.5px] leading-relaxed text-white/55 max-w-[260px]">Fast, reliable earnest money deposit financing for deal-makers in real estate, oil and gas, M&A, aviation, and beyond.

            </p>
            {/* Social Icons */}
            <div className="flex items-center gap-3 mt-1">
              <a
                href="https://x.com/EarnestBRG"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow EarnestBridge on X (Twitter)"
                className="w-8 h-8 rounded-full bg-white/8 hover:bg-[#52B788]/20 flex items-center justify-center text-white/50 hover:text-[#52B788] transition-all duration-200">

                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622Zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/earnest-bridge/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow EarnestBridge on LinkedIn"
                className="w-8 h-8 rounded-full bg-white/8 hover:bg-[#52B788]/20 flex items-center justify-center text-white/50 hover:text-[#52B788] transition-all duration-200">

                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
              <a
                href="https://www.facebook.com/Earnestbridge/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow EarnestBridge on Facebook"
                className="w-8 h-8 rounded-full bg-white/8 hover:bg-[#52B788]/20 flex items-center justify-center text-white/50 hover:text-[#52B788] transition-all duration-200">

                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Spacer */}
          <div className="hidden md:block md:col-span-1" />

          {/* Company Links */}
          <div className="md:col-span-2">
            <p className="text-[10px] font-semibold tracking-[0.18em] uppercase text-[#52B788] mb-4">Company</p>
            <ul className="flex flex-col gap-2.5">
              {[
              { label: 'Home', href: '/homepage' },
              { label: 'EMD Program', href: '/emd-program' },
              { label: 'Industries', href: '/industries' },
              { label: 'Pricing', href: '/pricing' }]?.
              map((link) =>
              <li key={link?.href}>
                  <Link
                  href={link?.href}
                  className="text-[13px] text-white/50 hover:text-white transition-colors duration-150">

                    {link?.label}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Resources Links */}
          <div className="md:col-span-2">
            <p className="text-[10px] font-semibold tracking-[0.18em] uppercase text-[#52B788] mb-4">Resources</p>
            <ul className="flex flex-col gap-2.5">
              {[
              { label: 'Blog', href: '/blog' },
              { label: 'EMD Program', href: '/emd-program' },
              { label: 'Contact', href: '/contact' }]?.
              map((link) =>
              <li key={link?.href}>
                  <Link
                  href={link?.href}
                  className="text-[13px] text-white/50 hover:text-white transition-colors duration-150">

                    {link?.label}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Contact Column */}
          <div className="md:col-span-3">
            <p className="text-[10px] font-semibold tracking-[0.18em] uppercase text-[#52B788] mb-4">Get in Touch</p>
            <div className="flex flex-col gap-3">
              <a
                href="mailto:deals@earnestbridge.com"
                className="flex items-center gap-2.5 text-[13px] text-white/50 hover:text-white transition-colors duration-150 group">

                <span className="w-6 h-6 rounded-md bg-white/8 flex items-center justify-center flex-shrink-0 group-hover:bg-[#52B788]/20 transition-colors">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect width="20" height="16" x="2" y="4" rx="2" />
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                  </svg>
                </span>
                deals@earnestbridge.com
              </a>
              <div className="mt-3 p-3.5 rounded-xl bg-white/5 border border-white/8">
                <p className="text-[11.5px] text-white/40 leading-relaxed">
                  Ready to close your deal?{' '}
                  <Link href="/contact" className="text-[#52B788] hover:text-[#74C69D] transition-colors font-medium">
                    Apply now →
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom Bar */}
      <div className="border-t border-white/8">
        <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="text-[11.5px] text-white/30">
            © 2026 EarnestBridge. All rights reserved.
          </span>
          <div className="flex items-center gap-5">
            <Link href="/privacy-policy" className="text-[11.5px] text-white/30 hover:text-white/60 transition-colors">
              Privacy Policy
            </Link>
            <span className="w-px h-3 bg-white/15" />
            <Link href="/terms" className="text-[11.5px] text-white/30 hover:text-white/60 transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>);

}